// Pure decision for the root layout gate (+layout.svelte). Extracted so the
// "what do we render" logic is unit-testable without Auth0 / browser deps.
//
// The load-bearing rule: a FAILED /me must NOT be conflated with "not onboarded".
// The first cut left `me = null` on a /me failure and the gate `!me?.onboarded`
// treated null as not-onboarded — so a transient /me outage during the manager's
// redeploy window dropped already-onboarded users into the onboarding wizard
// ("onboarding restarts each redeploy"). Here a failed /me (meError) routes to a
// 'reconnect' state instead; only a SUCCESSFUL /me with onboarded=false shows the
// wizard. The server-side requireOnboarded gate is the real enforcement boundary,
// so this is purely about not showing the wrong screen.

export type LayoutGate = 'auth-pending' | 'login' | 'me-pending' | 'reconnect' | 'onboarding' | 'app';

export function decideGate(s: {
	authReady: boolean;
	isAuthenticated: boolean;
	meReady: boolean;
	meError: boolean;
	onboarded: boolean | null;
}): LayoutGate {
	if (!s.authReady) return 'auth-pending';
	if (!s.isAuthenticated) return 'login';
	if (!s.meReady) return 'me-pending';
	// /me could not be determined (network / manager redeploy). Never assume
	// not-onboarded — show a reconnect state and let retry/reload recover it.
	if (s.meError) return 'reconnect';
	// /me resolved: only an explicit onboarded !== true shows the wizard.
	if (s.onboarded !== true) return 'onboarding';
	return 'app';
}
